module.exports = __webpack_public_path__ + "static/media/发货通知@2x.439a956d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_150/img/发货通知@2x.png
// module id = 1472
// module chunks = 0